import {
  useNetworkersRecommendations,
  useRecommendations,
} from 'containers/recommendations/hooks/useRecommendations'
import { RecommendationsGroup } from './RecommendationsGroup'
import { useProfile } from 'containers/profile/hooks/useProfile'
import { APP_LINKS, joinWithSlash } from 'utilities/links'

interface RecommendationsSectionProps {
  useRandomRecommendations?: boolean
}

export const RecommendationsSection = ({
  useRandomRecommendations,
}: RecommendationsSectionProps) => {
  const { profile } = useProfile()
  const { recommendations, isLoading } = useRecommendations()
  const { networkers, isLoading: loadingNetworkers } =
    useNetworkersRecommendations()

  return (
    <section className="flex full-w flex-column gap-20 px-20 px-0--tablet">
      {(loadingNetworkers || networkers.length > 0) && (
        <RecommendationsGroup
          isLoading={loadingNetworkers}
          title="🔥 Top Networkers"
          recommendations={networkers}
          to={joinWithSlash(
            profile?.username?.toLocaleLowerCase(),
            APP_LINKS.PROFILE_NETWORK + '#networkers'
          )}
          useRandomRecommendations={useRandomRecommendations}
        />
      )}
      {(isLoading || recommendations.length > 0) && (
        <RecommendationsGroup
          isLoading={isLoading}
          title="You may also be interested in"
          recommendations={recommendations}
          useRandomRecommendations={useRandomRecommendations}
          to={joinWithSlash(
            profile?.username?.toLocaleLowerCase(),
            APP_LINKS.PROFILE_NETWORK + '#hot-recommendations'
          )}
        />
      )}
    </section>
  )
}
